const TYPES = require('reducers/constructorRecommendations').ACTION_TYPES;

function updateConstructorRecommendations(recommendations) {
    return {
        type: TYPES.UPDATE_RECOMMENDATIONS,
        payload: recommendations
    };
}

function updateRequestData(requestData) {
    return {
        type: TYPES.UPDATE_REQUEST_DATA,
        payload: requestData
    };
}

module.exports = {
    TYPES,
    updateConstructorRecommendations,
    updateRequestData
};
